import React from 'react';
import moment from 'moment';
export default function DirectBookingFields({form,setForm,days,disabled=false}) {
 return <fieldset className="pipeline-direct-booking" disabled={disabled}>
  <label><input type="checkbox" checked={Boolean(form.bookNow)} onChange={e=>setForm(prev=>({...prev,bookNow:e.target.checked}))}/> Bereits vereinbarten Beratungstermin eintragen</label>
  {form.bookNow&&<>
   <p>Der Termin wird sofort bestätigt. Der Kunde muss keinen Einladungslink anklicken.</p>
   <div className="pipeline-appointment-edit-grid">
    <label>Beratungstag<select value={form.bookingDayId||''} onChange={e=>setForm(prev=>({...prev,bookingDayId:e.target.value}))}>
     <option value="">Bitte wählen</option>{days.map(day=><option key={day.dayId} value={day.dayId}>{moment(day.day).format('dddd, DD.MM.YYYY')}</option>)}
    </select></label>
    <label>Uhrzeit<input type="time" step="900" value={form.bookingTime||''} onChange={e=>setForm(prev=>({...prev,bookingTime:e.target.value}))}/></label>
   </div>
   {!days.length&&<p role="alert">Für diesen Standort gibt es noch keinen zukünftigen Beratungstag. Lege zuerst einen Beratungstag an.</p>}
   <label><input type="checkbox" checked={Boolean(form.sendConfirmation)} disabled={!form.email?.trim()} onChange={e=>setForm(prev=>({...prev,sendConfirmation:e.target.checked}))}/> Terminbestätigung per E-Mail senden (optional)</label>
   {!form.email?.trim()&&<small>Ohne E-Mail-Adresse wird der Termin trotzdem gebucht.</small>}
  </>}
 </fieldset>;
}
